
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecoflow-power-kits/components/Presale",
      function () {
        return require("private-next-pages/ecoflow-power-kits/components/Presale/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecoflow-power-kits/components/Presale"])
      });
    }
  